import { ApiFormParticipantStatus, FormParticipantStatusItems } from "@/types/forms/form.types.ts";
import { Tag, TagVariants } from "@skailer-com/uikit";

export const FormParticipantStatusTag = ({ status }: { status: ApiFormParticipantStatus }) => {
  const tagVariant: TagVariants = (() => {
    switch (status) {
      case ApiFormParticipantStatus.added:
      case ApiFormParticipantStatus.invited:
        return "warning";
      case ApiFormParticipantStatus.completed:
      case ApiFormParticipantStatus.canceled:
        return "secondary";
      case ApiFormParticipantStatus.in_progress:
        return "positive";
      default:
        return "positive";
    }
  })();

  const statusTitle = FormParticipantStatusItems().find((x) => x.id === status)?.title;

  return <Tag variant={tagVariant}>{statusTitle}</Tag>;
};
